const headerNavLinks = [{ href: '/blog', title: 'Blog' }]

export default headerNavLinks
